import { Identifiable } from '@custis/common';
import { ExpandMode, IHiddenColumn, TTableColumn, TTableRowMode } from '../models';
import { ColumnResizing, IdType, TableState } from 'react-table';
import { makeObservable, observable } from 'mobx';

export interface GridState<T extends Identifiable, TFilter, TSorting> {
  columns: TTableColumn<T, TFilter, TSorting>[];
  subRowColumns: TTableColumn<T, TFilter, TSorting>[];
  subRowId?: number;
  columnOrder: IdType<T>[];
  hiddenColumns: IHiddenColumn<T>[];
  highlightedId: string | undefined;

  tableState: TableState<T> | undefined;

  outerColumnResizing: ColumnResizing | undefined;

  expanded: Record<IdType<T>, boolean>;

  expandedAllMode: ExpandMode;

  tableRowMode: TTableRowMode;

  pageCount: number;
}

export class GridStateStore<T extends Identifiable, TFilter, TSorting> implements GridState<T, TFilter, TSorting> {
  @observable.ref
  columnOrder: IdType<T>[] = [];

  @observable.ref
  hiddenColumns: IHiddenColumn<T>[] = [];

  @observable
  columns: TTableColumn<T, TFilter, TSorting>[] = [];

  @observable
  subRowColumns: TTableColumn<T, TFilter, TSorting>[] = [];

  @observable
  subRowId = undefined;

  // Не удаляйте = undefined: без этого mobx перестает отслеживать изменения
  @observable
  highlightedId: string | undefined = undefined;

  // Не удаляйте = undefined: без этого mobx перестает отслеживать изменения
  @observable.ref
  tableState: TableState<T> | undefined = undefined;

  @observable.ref
  expanded: Record<IdType<T>, boolean> = {} as Record<IdType<T>, boolean>;

  // Не удаляйте = undefined: без этого mobx перестает отслеживать изменения
  @observable.ref
  outerColumnResizing: ColumnResizing | undefined = undefined;

  @observable
  tableRowMode: TTableRowMode = 'view';

  @observable
  pageCount = 0;

  @observable expandedAllMode = ExpandMode.CLOSED;

  constructor() {
    makeObservable(this);
  }
}
